import type { IRangeValue } from "~/types/range";

import type { IFilterRangeFormValues } from "./schema";

export const toFormValues = (value?: IRangeValue): IFilterRangeFormValues => ({
  min: value?.min ?? null,
  max: value?.max ?? null,
});

export const toEmittedValue = (value: IFilterRangeFormValues): IRangeValue => ({
  min: value.min ?? undefined,
  max: value.max ?? undefined,
});

export const isSameFormValue = (a?: IRangeValue, b?: IRangeValue) =>
  (a?.min ?? null) === (b?.min ?? null) &&
  (a?.max ?? null) === (b?.max ?? null);
